<div class="flex flex-col pt-6 h-svh">
  <div class="self-end">
    <img
      (click)="closeTab()"
      class="mr-2 cursor-pointer"
      src="../../../../../assets/images/svg/cross-close.svg"
    />
  </div>
  <div class="flex-1 text-center content-center">
    <img src="../../../../../assets/images/svg/bank-connection-ok.svg" class="m-auto" />
    <p class="font-bold text-lg mt-6">{{ 'connection_successfull' | translate }}</p>
    <p class="mt-4 text-sm">{{ 'you_can_close_this_tab' | translate }}</p>
  </div>
  <app-auto-closed-button
    class="mb-7"
    [closeCallback]="closeTab"
    [delayInSeconds]="5"
    [text]="'close_tab' | translate"
  ></app-auto-closed-button>
</div>
